import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import FolderIcon from "@mui/icons-material/Folder";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useDispatch, useSelector } from "react-redux";
import { createAxios } from "../../createAxios";
import { createDocument, uploadImage } from "../../redux/apiRequest";
import AdminFormFrame from "../AdminFormFrame/AdminFormFrame";
import { getUserId } from "../../utils/authSession";

const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    bgcolor: "var(--toeic-surface)",
    "& fieldset": { borderColor: "var(--toeic-line)", borderStyle: "dotted" },
    "&:hover fieldset": { borderColor: "var(--toeic-sky)" },
    "&.Mui-focused fieldset": { borderColor: "var(--toeic-sky)", borderWidth: 1.5 },
  },
  "& .MuiInputLabel-root": { fontWeight: 500 },
  "& .MuiInputLabel-root.Mui-focused": { color: "var(--toeic-sky-deep)" },
};

function CreateDocument() {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [link, setLink] = useState("");
  const [isImageLoading, setIsImageLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.signin.currentUser);
  const accessToken = currentUser?.metadata.tokens.accessToken;
  const userID = getUserId(currentUser);
  const axiosJWT = createAxios(currentUser);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const documentData = {
      name: name,
      content: description,
      image: "",
      link: link,
    };

    if (file) {
      setIsImageLoading(true);
      const imageData = await uploadImage(file, "", dispatch);

      if (imageData.img_url) {
        documentData.image = imageData.img_url;
      }
      setIsImageLoading(false);
    }

    await createDocument(
      accessToken,
      userID,
      documentData,
      dispatch,
      navigate,
      axiosJWT
    );
  };


  return (
    <AdminFormFrame
      title="Create Document"
      eyebrow="Document management"
      description="Publish a new learning resource with a cover image and download link."
      icon={FolderIcon}
      color="#35c759"
      bg="#e8f9ed"
      backHref="/management/document"
      tips={["Use a practical document title.", "Paste a valid public download link.", "Upload an image that helps learners identify the resource."]}
    >
      <form onSubmit={handleSubmit}>
        <Box mb={2}>
          <TextField
            fullWidth
            label="Name"
            variant="outlined"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={fieldSx}
          />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            label="Description"
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={fieldSx}
          />
        </Box>
        <Box mb={2}>
          <TextField
            fullWidth
            label="Link"
            variant="outlined"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            sx={fieldSx}
          />
        </Box>
        <Box mb={2}>
          <Button variant="outlined" component="label" fullWidth startIcon={<UploadFileIcon />} sx={{ borderRadius: "14px", borderStyle: "dotted", fontWeight: 700 }}>
            {isImageLoading ? (
              <>
                <CircularProgress style={{ color: "#FFFFFF" }} size={24} />
                &nbsp;Updating Image...
              </>
            ) : (
              "Upload Image"
            )}
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
        </Box>
        <Box mb={2}>
          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ borderRadius: "14px", bgcolor: "#35c759", color: "#ffffff", fontWeight: 700, "&:hover": { bgcolor: "#2fb44f" } }}
          >
            Submit
          </Button>
        </Box>
      </form>
    </AdminFormFrame>
  );
}

export default CreateDocument;



